import {useState} from "react";
import axios from "axios";
import UtilFunctions from "../Helpers/Utils";

/**
 * Component that render an input with postal codes suggestions in autocompletion
 *
 * @param onPostalCodeChange
 * @param oldValue
 * @param refUrl
 * @param cityName
 * @param postalCodeName
 * @param formik
 * @returns {JSX.Element}
 * @constructor
 */
const AutoCompletePostalCode = ({onPostalCodeChange, oldValue, refUrl, cityName, postalCodeName, formik}) => {

	const [suggestions, setSuggestions] = useState([]);
	const [suggestionIndex, setSuggestionIndex] = useState(0);
	const [suggestionsActive, setSuggestionsActive] = useState(false);
	const [value, setValue] = useState(oldValue);
	const [isFocus, setIsFocus] = useState(false);
	const [isBlur, setIsBlur] = useState(false);

	const handleChange = (e) => {
		const query = e.target.value.toLowerCase();
		setValue(query);
		if (query.length > 2) {

			axios.get(refUrl + "/search?country_code_iso3=FRA&q=" + query).then((response) => {
				let data = response.data
				setSuggestions(data);
				setSuggestionsActive(true);

			}).catch(error => {
				console.log(error)
			})
		} else {
			setSuggestionsActive(false);
		}
	};
	const handleOnFocus = (e) => {
		setIsFocus(true);
		setIsBlur(false);

	}
	const handleOnBlured = (e) => {
		setIsFocus(false);
		setIsBlur(true);

	}

	const handleClick = (e, index) => {
		setSuggestions([]);
		onPostalCodeChange(suggestions[index], cityName, postalCodeName, formik)
		setValue(suggestions[index].postal_code);
		setSuggestionsActive(false);
	};

	const handleKeyDown = (e) => {

		UtilFunctions.preventNumericSymbols(e);

		// UP ARROW
		if (e.keyCode === 38) {
			if (suggestionIndex === 0) {
				return;
			}
			setSuggestionIndex(suggestionIndex - 1);
		}
		// DOWN ARROW
		else if (e.keyCode === 40) {
			if (suggestionIndex - 1 === suggestions.length) {
				return;
			}
			setSuggestionIndex(suggestionIndex + 1);
		}
		// ENTER
		else if (e.keyCode === 13) {
			setValue(suggestions[suggestionIndex].postal_code);
			onPostalCodeChange(suggestions[suggestionIndex], cityName, postalCodeName, formik)
			setSuggestionIndex(0);
			setSuggestionsActive(false);
		}
	};

	const Suggestions = () => {
		return (
			<div className={`autocomplete-suggestions ${isFocus ? "active" : ""} `}>
				{suggestions.map((suggestion, index) => {
					return (
						<div

							className={`autocomplete-suggestion ${index === suggestionIndex ? "active" : ""}`}
							key={index}
							onClick={(e) => handleClick(e, index)}
						>
							{suggestion.display_name}
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<div className="container_autocomplete">
			<input
				className="form-control"
				placeholder="Ex: 75001"
				type="number"
				value={value}
				onFocus={handleOnFocus}
				onBlur={handleOnBlured}
				onChange={handleChange}
				onKeyDown={handleKeyDown}
			/>
			{suggestionsActive && <Suggestions/>}
		</div>
	);

};

export default AutoCompletePostalCode;
